import {
    Banner,
    Genie,
    GenieHeaderButton,
    GenieSidePanel,
    GenieSidebarButton,
    GenieProps,
    GenieFloater,
} from "@kaltura/mediaspace-features-genie";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";
import { createRoot } from "react-dom/client";

export { Banner, Genie, GenieHeaderButton, GenieSidePanel, GenieSidebarButton };
export const renderGeniePage = getDsLayoutComponentRenderer(Genie);

/** Floating Genie button for non-DS pages. Renders into a dynamically created body-appended div. */
export const FloatingWidget = {
    render: (props: GenieProps) => {
        const rootElement = document.createElement("div");
        document.body.append(rootElement);
        const root = createRoot(rootElement);
        root.render(<GenieFloater {...props} />);
    },
};
